import { DashboardProfileDesktop } from './dashboard-profile-page-desktop'
import { DashboardProfileMobile } from './dashboard-profile-page-mobile'

export function DashboardProfilePage() {
  return (
    <section className="flex w-full flex-col">
      <DashboardProfileDesktop />
      <DashboardProfileMobile />
    </section>
  )
}
